import { Button, Grid } from '@material-ui/core/';
import { Skeleton } from '@material-ui/lab';
import classNames from 'classnames';
import Link from 'next/link';
import React from 'react';
// import { useSelector } from 'react-redux';
import useStyles from '~/components/PowerYourRestaurantWithPOS.style.js';
import Callout from '~/components/ui-kit/Callout/Callout';
import { useAppConfig } from '~/hooks/useAppConfig.js';
import ImageBox from './ImageBox.jsx';

const PowerYourRestaurantWithPOS = () => {
  // const { locale } = useSelector((state) => state.app);
  const classes = useStyles();

  const appConfig = useAppConfig();

  if (appConfig.isLoading) {
    return <Skeleton variant='rect' height={550} width='100%' />;
  }

  return (
    <Grid
      container
      item
      xs={11}
      sm={11}
      justify='flex-start'
      className={classNames(classes.limitedWidth, classes.downloadContainer)}>
      <Grid
        container
        item
        xs={10}
        lg={8}
        md={10}
        alignItems='center'
        justify='center'
        alignContent='flex-start' style={{ position: 'relative', zIndex: 2 }}>
        <Callout
          title='Power Your Restaurant with Chowbus POS'
          text=''
        >
          <span className={classNames(classes.posFeaturePoint)}>Save $8,000/mo on labor costs per location</span>
          <span className={classNames(classes.posFeaturePoint)}>Grow your business 25%</span>
        </Callout>
        <Grid container style={{ marginBottom: 20, marginTop: 20, }} spacing={1}>
          <Grid item xs={12} md={6} className={classes.textMe} container justify='center'>
            <Button
              variant='contained'
              color='primary'
              href={'https://pos.chowbus.com'} target="_blank"
              style={{
                height: 45,
                borderRadius: 30,
                width: '100%',
                padding: '6px 15px',
                fontWeight: '700',
              }}>
              Learn More
            </Button>
          </Grid>
        </Grid>
        <Grid
          item
          container
          alignItems='center'
          justify='flex-end'
          xs={10}
          sm={8}
          className={classNames(classes.featuredImageContainer)}
          style={{ marginTop: 10, maxHeight: 520 }}>
          <Grid item style={{ width: 366, overflow: 'hidden', position: 'relative', zIndex: 2 }}>
            <Link href='https://pos.chowbus.com'>
              <a target="_blank">
                <ImageBox
                  style={{ width: '100%' }}
                  src='/homepage/landing-home-power_your_restaurant_with_POS.png'
                  alt='Power Your Restaurant with Chowbus POS'
                />
              </a>
            </Link>
          </Grid>
        </Grid>
      </Grid>

    </Grid>
  );
};

export default PowerYourRestaurantWithPOS;
